// Styles for Messages Component go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledMessages = styled.div`
  .message-link:hover {
    font-weight: ${baseVariables?.font?.fontWeightRegular};
  }
`;
